import { searchWithinStyles } from "@insite/content-library/Widgets/ProductList/ProductListSearchWithin";
import { css } from "styled-components";

searchWithinStyles.wrapper = {
    css: css`
        background-color: #f0f4f3;
        padding: 15px;
    `,
};

searchWithinStyles.titleText = {
    variant: "h6",
    fontFamily: "LatoBold",
    css: css`
        font-style: normal;
    `,
};
